import { Subject } from '@src/main/modules/messages/domain/subject/subject.interface';
import { SubjectRepository } from '@src/main/modules/messages/domain/subject/subject.repository';

export const findAllSubjects = async (repository: SubjectRepository): Promise<Subject[]> =>
  await repository.findAll();
